export default __webpack_public_path__ + "static/media/3047.9522dce2.jpg";